<div class="left-modal">
  <div class="close" (click)="close()"></div>
  @if (loading) {
    <div class="loader"></div>
  }
  @if (!loading) {
    <div class="modal-container">
      @if (!clip) {
        <h1>{{'Add clip' | translate}}</h1>
      }
      @if (clip) {
        <h1>{{'Edit clip' | translate}}</h1>
      }
      @if (error) {
        <div class="errorMessage">{{error | translate}}</div>
      }
      <form #form="ngForm" (ngSubmit)="submitForm()" novalidate>
        @if (!shSchHasSceneId) {
          <div class="L-6 M-6 S-6 columns">
            <label>{{'Date' | translate}}</label>
            <input type="date" name="date" [(ngModel)]="data.date" required (blur)="getShootingScenes()">
          </div>
          <div class="L-6 M-6 S-6 columns">
            <label>{{'Unit' | translate}}</label>
            <app-dropdown
              [(appModel)]="data.unit"
              [list]="units"
              [value]="'id'"
              [name]="'unit_name'"
              [multiple]="false"
              [required]="true"
              (onClose)="getShootingScenes()"
            ></app-dropdown>
          </div>
          <div class="L-12 M-12 S-12 columns">
            <label>{{'Scenes' | translate}}</label>
            <app-dropdown
              [(appModel)]="data.sh_sch_has_scene_id"
              [list]="shootingScenes"
              [value]="'id'"
              [name]="'scene_number'"
              [multiple]="false"
              [required]="true"
              [disabled]="!data.unit || !data.date"
              (onClose)="getData()"
            ></app-dropdown>
          </div>
        }
        <!-- Adds clip with shooting scene -->
        @if (data.sh_sch_has_scene_id) {
          <div class="L-4 M-4 S-4 columns">
            <label>{{'Shot' | translate}}**</label>
            <input class="centered" type="text" name="shoot" [(ngModel)]="data.shoot" required>
          </div>
          <div class="L-4 M-4 S-4 columns">
            <label>{{'Take' | translate}}**</label>
            <input class="centered" type="text" name="take" [(ngModel)]="data.take" required>
          </div>
          <div class="L-4 M-4 S-4 columns">
            <label>{{'Duration' | translate}}**</label>
            <app-minutes-input [required]="true" [(appModel)]="data.duration_seconds"></app-minutes-input>
          </div>
          @for (cm of data.cameras; track cm; let i = $index) {
            <div class="row">
              <h3>{{cm.camera_name_eng}}</h3>
              <div class="L-4 M-4 S-4 columns">
                <label>{{'Roll/clip' | translate}}</label>
                <input type="text" name="{{'roll_clip_' + i}}" [(ngModel)]="cm.roll_clip">
              </div>
              <div class="L-8 M-8 S-8 columns">
                <label>{{'Description' | translate}}</label>
                <textarea rows="3" name="{{'description_' + i}}" [(ngModel)]="cm.description" placeholder="{{'Insert text' | translate}}" ></textarea>
              </div>
            </div>
          }
          <div class="L-12 M-12 S-12 columns">
            <label>{{'Notes' | translate}}</label>
            <textarea rows="3" name="notes" [(ngModel)]="data.notes" placeholder="{{'Insert text' | translate}}" ></textarea>
          </div>
          <div class="L-12 M-12 S-12 columns">
            <label>{{'Director notes' | translate}}</label>
            <textarea rows="3" name="director_notes" [(ngModel)]="data.director_notes" placeholder="{{'Insert text' | translate}}" ></textarea>
          </div>
          <div class="L-12 M-12 S-12 columns">
            <label>{{'Sound notes' | translate}}</label>
            <textarea rows="3" name="sound_notes" [(ngModel)]="data.sound_notes" placeholder="{{'Insert text' | translate}}" ></textarea>
          </div>
          <div class="L-12 M-12 S-12 columns">
            <div class="checkBoxCOnt">
              <input type="checkbox" name="selected_clip" [(ngModel)]="data.selected_clip">
              <p class="checkbox">{{'Selected clip' | translate}}</p>
            </div>
          </div>
          <div class="L-12 M-12 S-12 columns TextCentered">
            <input name="sumbit" type="submit" value="{{'Save' | translate}}"  [attr.disabled]="form.invalid || !data.duration_seconds ?'':null">
          </div>
          <div class="L-12 M-12 S-12 columns TextCentered">
            <a class="button cancel" (click)="close()">{{'Cancel' | translate}}</a>
          </div>
        }
      </form>
    </div>
  }
</div>